import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { UrlService } from '@core/services/url/url.service';

import { File } from '@core/objects/file';
import { Version } from '@core/objects/version';
import { VersionFeedback, FeedbackStatusColorValues, ApprovalStatusColorValues,FeedbackStatusCodeEnum } from '@core/models/version-feedback';


@Component({
    selector: 'core-version-files-list-checkbox',
    templateUrl: './list-checkbox.component.html',
    styleUrls: ['./list-checkbox.component.scss']
})
export class VersionFilesListCheckboxComponent implements OnInit, OnChanges {

    public readonly FEEDBACK_STATUS_COLORS = FeedbackStatusColorValues;

    public readonly LOADING = 0;
    public readonly DONE = 1;
    public readonly ERROR = 2;

    @Input() version: Version;
    @Input() disabled: boolean; // TODO
    @Input() feedbacks: Array<VersionFeedback>; // TODO
    @Input()  selected: Array<File>;
    @Output() selectedChange = new EventEmitter<Array<File>>();

    public opened: boolean = false;
    public firstOpened: boolean = false;
    public filesUrl: string = "";
    public checked: boolean = false;

    protected feedbacksList: Array<VersionFeedback>;

    constructor(private httpClient: HttpClient, private urlSrv: UrlService ) { }

    ngOnInit() {
        this.filesUrl = "/versions/"+ this.version.id +"/files";
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.feedbacks && changes.feedbacks.currentValue != null){
            this.feedbacksList = this.feedbacks;
        }
    }

    onChange(files: Array<File>) {
        this.selected = files;
        this.selectedChange.emit(this.selected);
    }

    openFiles() {
        this.firstOpened = true;
        this.opened = !this.opened;
    }

    public getBubbleColor(feedback: VersionFeedback){
        let color;
        // fix for wrong status  or approval in feedbacks to set it yellow. <diego@twonas.com>
        if(feedback.approval == null && feedback.status == null){
            return this.FEEDBACK_STATUS_COLORS[FeedbackStatusCodeEnum.WRONG_CODE];
        }
        if (feedback.approval != null){
            color = ApprovalStatusColorValues[feedback.approval.status_code];
        } else {
            color = FeedbackStatusColorValues[feedback.status.status_code];
        }
        return color;
        
    }

}
